import { TypedEvent } from '@xyo-network/world-typechain'
import { createContext } from 'react'

export interface MinterEvents {
  busy?: boolean
  eventType?: string
  events?: TypedEvent[]
  refresh?: () => void
  updateEventType?: (eventType: string) => void
}

export const MinterEventsContext = createContext<MinterEvents>({})
